var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { CheckCircleOutlined, DashboardOutlined, LogoutOutlined, RadiusUpleftOutlined, SafetyCertificateOutlined, SearchOutlined, SwitcherFilled, UserOutlined, } from '@ant-design/icons';
import { Layout, Menu, Tooltip, Avatar, Space, Dropdown, Row, Col, Typography } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import AppRoutes from '../routes/routes';
import one_source_connect from '../assets/images/one_source_connect.png';
import { useLocation } from 'react-router-dom';
import Notifications from '../components/common/notifications';
import { useDispatch, useSelector } from 'react-redux';
import useInactivityTimeout from '../components/common/useInactivityTimeout';
import SearchBar from '../components/common/searchBar';
import { clearState, setKeywordSearchStr } from '../context/reducers/userReducer';
import mdmService from '../services/MDMService';
import { getBOMSearchSuggestions, getSearchSuggestions } from '../services/projectService';
import { getCertSearchSuggestions } from '../services/certificateService';
import subProjectService from '../services/subProjectService';
import { Footer } from 'antd/es/layout/layout';
import "../styles/layout.css";
import { clearTokenLogout } from '../utils/commonUtil';
const { Header, Content } = Layout;
const getKeyFromPath = (path) => {
    if (path === '/dashboard') {
        return '1';
    }
    else if (path.startsWith('/projects')) {
        return '2';
    }
    else if (path.startsWith('/certificates')) {
        return '3';
    }
    else if (path.startsWith('/requirements') ||
        path.startsWith('/regulation-information/details') ||
        path.startsWith('/reg-info-compare')) {
        return '4';
    }
    else if (path.startsWith('/regulations')) {
        return '5';
    }
    else if (path.startsWith('/account')) {
        return '0';
    }
    else if (path.startsWith('/vendor')) {
        return '2';
    }
    else {
        return '0'; // Default to "0" if no match
    }
};
const AppLayout = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    useInactivityTimeout();
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const [defaultSelectedKeys, setDefaultSelectedKeys] = useState([getKeyFromPath(pathname)]);
    const applicationData = useSelector((state) => state.applicationData);
    const [keywordSearchOptionsData, setKeywordSearchOptionsData] = useState();
    const [screenId, setScreenId] = useState(0);
    const dispatch = useDispatch();
    let isVendorLogin = (applicationData === null || applicationData === void 0 ? void 0 : applicationData.userRole) == 2 ? true : false;
    const [color, setColor] = useState('#00a2ae');
    const [searchBarKey, setSearchBarKey] = useState(0);
    const [searchIconText, setSearchIconText] = useState('');
    const [imageSrc, setImageSrc] = useState(undefined);
    useEffect(() => {
        if (applicationData === null || applicationData === void 0 ? void 0 : applicationData.companyId) {
            try {
                setImageSrc(require(`../assets/logos/${applicationData === null || applicationData === void 0 ? void 0 : applicationData.companyId}.jpg`));
            }
            catch (error) {
            }
        }
    }, []);
    function boolScreenAccess(screenId) {
        var _a, _b, _c, _d;
        return ((_d = (_c = (_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.getClientUserScreenAccess) === null || _a === void 0 ? void 0 : _a.lstClientUserCompanies) === null || _b === void 0 ? void 0 : _b.find((obj) => { var _a, _b; return obj.intId === ((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.intCompanyID); })) === null || _c === void 0 ? void 0 : _c.lstObjLuScreens) === null || _d === void 0 ? void 0 : _d.find((obj) => obj.intId === screenId)) != undefined;
    }
    useEffect(() => {
        handleScreenChange();
    }, [pathname, keywordSearchOptionsData]);
    useEffect(() => {
        setSearchBarKey(prevKey => prevKey + 1);
        setSearchIconText('');
    }, [pathname]);
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f;
        if ((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserName) {
            setColor(getColorByRange(((_d = (_c = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _c === void 0 ? void 0 : _c.userLoginDetails) === null || _d === void 0 ? void 0 : _d.strUserName) ?
                (_f = (_e = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _e === void 0 ? void 0 : _e.userLoginDetails) === null || _f === void 0 ? void 0 : _f.strUserName[0] : '-'));
        }
    }, [(_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserName]);
    // useEffect(() => {
    //   if(applicationData?.userRole === 1)
    //   {
    //     setDefaultSelectedKeys(['1']);
    //     setScreenId(1);
    //   }
    // }, [applicationData?.selClientList]);
    const disabledStyle = {
        color: 'grey',
        cursor: 'not-allowed',
    };
    const handleOnsearchIcon = () => {
        dispatch(setKeywordSearchStr(searchIconText));
    };
    const handleKeywordSearch = (value) => {
        var _a, _b;
        setSearchIconText(value);
        if (value && (value === null || value === void 0 ? void 0 : value.length) > 2) {
            if (screenId === 5) {
                mdmService.getRegLibSearchSuggestions(JSON.stringify(value)).
                    then((res) => setKeywordSearchOptionsData(res));
            }
            else if (screenId === 2) {
                let statisStrings = [
                    'Project Id - ',
                    'Product Name - ',
                    'Brand Name - ',
                    'Product Model - ',
                    'Project Status - ',
                    'BV Location - ',
                    'Project Type - '
                ];
                let searchStr = value;
                if (statisStrings.includes(value.substring(0, value.indexOf('-') + 2))) {
                    searchStr = value.substring(value.indexOf('-') + 2).trim();
                }
                let searchPrjRequest = {
                    lstLuCompany: applicationData === null || applicationData === void 0 ? void 0 : applicationData.selClientList,
                    strSearchBoxText: searchStr
                };
                getSearchSuggestions(searchPrjRequest).then((res) => setKeywordSearchOptionsData(res));
            }
            else if (screenId === 3) {
                let searchCertRequest = {
                    lstLuCompany: applicationData === null || applicationData === void 0 ? void 0 : applicationData.selClientList,
                    strSearchBoxText: value
                };
                getCertSearchSuggestions(searchCertRequest).then((res) => setKeywordSearchOptionsData(res));
            }
            else if (screenId === 4) {
                getBOMSearchSuggestions(value).then((res) => setKeywordSearchOptionsData(res));
            }
            else if (screenId === 21) {
                let stringData = [
                    'Sub Project Id - ',
                ];
                let subPrjSearchStr = '';
                if (stringData.includes(value.substring(0, value.indexOf('-') + 2))) {
                    subPrjSearchStr = value.substring(value.indexOf('-') + 2).trim();
                }
                else {
                    subPrjSearchStr = value;
                }
                if (subPrjSearchStr) {
                    let data = {
                        intId: (_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.intCompanyID, //2376204,
                        strLongDesc: subPrjSearchStr
                    };
                    subProjectService.getSearchSuggestions(JSON.stringify(data), 'getVendorSubProjectSearchSuggestions').then((res) => setKeywordSearchOptionsData(res));
                }
            }
        }
    };
    const handleScreenChange = () => {
        if (pathname.startsWith('/dashboard')) {
            setScreenId(1);
            setDefaultSelectedKeys(['1']);
        }
        else if (pathname.startsWith('/projects')) {
            setScreenId(2);
            setDefaultSelectedKeys(['2']);
        }
        else if (pathname.startsWith('/certificates')) {
            setScreenId(3);
            setDefaultSelectedKeys(['3']);
        }
        else if (pathname.startsWith('/requirements')) {
            setScreenId(4);
            setDefaultSelectedKeys(['4']);
        }
        else if (pathname.startsWith('/regulations')) {
            setScreenId(5);
            setDefaultSelectedKeys(['5']);
        }
        else if (pathname.startsWith('/vendor')) {
            setScreenId(2);
            setDefaultSelectedKeys(['2']);
        }
        else {
            setDefaultSelectedKeys(['0']); // Default to "0" if no match
            setScreenId(0);
        }
    };
    const handleLogout = () => __awaiter(void 0, void 0, void 0, function* () {
        dispatch(clearState());
        yield clearTokenLogout();
    });
    const items = [
        {
            key: 's1',
            label: 'My Profile',
            icon: _jsx(UserOutlined, {}),
            onClick: () => navigate('/account'),
            disabled: !boolScreenAccess(6),
        },
        ...(((_c = applicationData === null || applicationData === void 0 ? void 0 : applicationData.lstClientVendor) === null || _c === void 0 ? void 0 : _c.length) > 1 &&
            ((_f = (_e = (_d = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _d === void 0 ? void 0 : _d.userLoginDetails) === null || _e === void 0 ? void 0 : _e.strUserEmailId) === null || _f === void 0 ? void 0 : _f.endsWith('@bureauveritas.com'))
            ? [{
                    key: 's3',
                    label: 'Switch Company',
                    icon: _jsx(SwitcherFilled, {}),
                    onClick: () => navigate('/login'),
                }]
            : []),
        {
            key: 's2',
            label: 'Sign Out',
            icon: _jsx(LogoutOutlined, {}),
            onClick: () => handleLogout()
        },
    ];
    const ColorList = ['#f56a00', '#ffbf00', '#7265e6', '#00a2ae'];
    const getInitials = (name) => {
        var _a, _b;
        if (!name.trim()) {
            throw new Error("Name cannot be empty or just spaces.");
        }
        const parts = name.trim().split(/[ .]+/);
        // Handle case where we only get one part after splitting
        if (parts.length === 1) {
            return parts[0][0].toUpperCase();
        }
        const [first, second] = parts;
        if (!first || !second) {
            throw new Error("Both first and second name parts are required for initials.");
        }
        return (((_a = first[0]) === null || _a === void 0 ? void 0 : _a.toUpperCase()) || "") + (((_b = second[0]) === null || _b === void 0 ? void 0 : _b.toUpperCase()) || "");
    };
    const getColorByRange = (initials) => {
        const firstChar = initials.toUpperCase(); // Use the first letter of the initials
        if (/[A-D]/.test(firstChar)) {
            return ColorList[0];
        }
        else if (/[E-J]/.test(firstChar)) {
            return ColorList[1];
        }
        else if (/[K-P]/.test(firstChar)) {
            return ColorList[2];
        }
        else if (/[Q-Z]/.test(firstChar)) {
            return ColorList[3];
        }
        return '#00a2ae'; // Default color for unexpected cases
    };
    return (_jsxs(Layout, { children: [_jsxs(Header, { style: {
                    position: 'sticky',
                    top: 0,
                    zIndex: 1000,
                    padding: '0px 40px 0px 10px',
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: '#43485F'
                }, children: [_jsx("img", { src: one_source_connect, alt: "Description of the image", style: { height: '40px', marginRight: '16px', background: '#43485F' } }), screenId === 2 || screenId === 3 || screenId === 4 || screenId === 5 || screenId === 21 ? (_jsx(SearchBar, { data: keywordSearchOptionsData, placeholder: screenId === 5
                            ? 'Search Regulation Library'
                            : screenId === 2
                                ? 'Search project, product, brand, product model, status, location and type.......'
                                : screenId === 3
                                    ? 'Search certificates ids, names, service name, models, series models, primary models, etc...'
                                    : screenId === 4
                                        ? 'Search Country, Service Type, Product Type, Technology Type'
                                        : screenId === 21
                                            ? 'Search sub project'
                                            : '', handleOnSelect: (value, option) => dispatch(setKeywordSearchStr(value)), handleSearch: handleKeywordSearch, handleSearchIconClick: handleOnsearchIcon }, searchBarKey)) : (_jsx("div", { style: { width: '0%' } })), _jsx(_Fragment, { children: !isVendorLogin ? (_jsx(Menu, { theme: "light", mode: "horizontal", defaultSelectedKeys: defaultSelectedKeys || ['1'], onChange: handleScreenChange, style: { flex: 1, minWidth: 0, justifyContent: 'end', background: '#43485F' }, items: [
                                {
                                    key: '1',
                                    icon: _jsx(DashboardOutlined, {}),
                                    label: boolScreenAccess(1) ? (_jsx(Link, { to: "/dashboard", children: "Dashboard" })) : (_jsx(Tooltip, { children: _jsx("span", { style: disabledStyle, children: "Dashboard" }) }))
                                },
                                {
                                    key: '2',
                                    icon: _jsx(SearchOutlined, {}),
                                    label: ((_g = applicationData === null || applicationData === void 0 ? void 0 : applicationData.subscriptionDetails) === null || _g === void 0 ? void 0 : _g.boolProjectSearchProjectDetail) ? (boolScreenAccess(2) ? (_jsx(Link, { to: "/projects", children: "Projects" })) : (_jsx(Tooltip, { children: _jsx("span", { style: disabledStyle, children: "Projects" }) }))) : (_jsx(Tooltip, { title: "Please Upgrade Membership.", children: _jsx("span", { style: disabledStyle, children: "Projects" }) }))
                                },
                                {
                                    key: '3',
                                    icon: _jsx(SafetyCertificateOutlined, {}),
                                    label: ((_h = applicationData === null || applicationData === void 0 ? void 0 : applicationData.subscriptionDetails) === null || _h === void 0 ? void 0 : _h.boolCertificateSearchPage) ? (boolScreenAccess(3) ? (_jsx(Link, { to: "/certificates", children: "Certificates" })) : (_jsx(Tooltip, { children: _jsx("span", { style: disabledStyle, children: "Certificates" }) }))) : (_jsx(Tooltip, { title: "Please Upgrade Membership.", children: _jsx("span", { style: disabledStyle, children: "Certificates" }) }))
                                },
                                {
                                    key: '4',
                                    icon: _jsx(CheckCircleOutlined, {}),
                                    label: ((_j = applicationData === null || applicationData === void 0 ? void 0 : applicationData.subscriptionDetails) === null || _j === void 0 ? void 0 : _j.boolRequirementsRequirementPage) ? (boolScreenAccess(4) ? (_jsx(Link, { to: "/requirements", children: "Requirements" })) : (_jsx(Tooltip, { children: _jsx("span", { style: disabledStyle, children: "Requirements" }) }))) : (_jsx(Tooltip, { title: "Please Upgrade Membership.", children: _jsx("span", { style: disabledStyle, children: "Requirements" }) }))
                                },
                                {
                                    key: '5',
                                    icon: _jsx(RadiusUpleftOutlined, {}),
                                    label: boolScreenAccess(5) ? (_jsx(Link, { to: "/regulations", children: "Regulations" })) : (_jsx(Tooltip, { children: _jsx("span", { style: disabledStyle, children: "Regulations" }) }))
                                },
                                // {
                                //   key: '6',
                                //   icon: (
                                //     <div style={{ verticalAlign: 'middle' }}>
                                //       {imageSrc != null && imageSrc != undefined && (
                                //         <Tooltip
                                //           color="#00A4A4"
                                //           title={applicationData?.loggedInClient?.userLoginDetails?.strCompanyName}>
                                //           <img
                                //             src={imageSrc}
                                //             alt={'company-logo'}
                                //             style={{ height: '40px', marginTop: '-3px', marginRight: '20px' }}
                                //           />
                                //         </Tooltip>
                                //       )}
                                //       <Avatar
                                //         className="custom-avator-font-color"
                                //         size={28}
                                //         style={{ fontSize: '11px', backgroundColor: color }}>
                                //         {applicationData?.loggedInClient?.userLoginDetails?.strUserName ? (
                                //           getInitials(
                                //             applicationData?.loggedInClient?.userLoginDetails?.strUserName
                                //           )
                                //         ) : (
                                //           <UserOutlined />
                                //         )}
                                //       </Avatar>
                                //     </div>
                                //   ),
                                //   label: (
                                //     // <Dropdown overlay={<Menu items={items} />}
                                //     //           trigger={['hover']}>
                                //     <span>{applicationData?.loggedInClient?.userLoginDetails?.strUserName}</span>
                                //   ),
                                //   // </Dropdown>
                                //   children: items,
                                //   className: 'custom-hover-menu'
                                // }
                            ] })) : (_jsx(Menu, { theme: "light", mode: "horizontal", defaultSelectedKeys: defaultSelectedKeys, style: { flex: 1, minWidth: 0, justifyContent: 'end', background: '#43485F' }, items: [
                                {
                                    key: '2',
                                    icon: _jsx(SearchOutlined, {}),
                                    label: _jsx(Link, { to: "/vendor", children: "Projects" })
                                },
                                // {
                                //   key: '6',
                                //   icon: (
                                //     <Avatar
                                //       className="custom-avator-font-color"
                                //       size={28}
                                //       style={{ fontSize: '11px', backgroundColor: color }}>
                                //       {applicationData?.loggedInClient?.userLoginDetails?.strUserName ? (
                                //         getInitials(applicationData?.loggedInClient?.userLoginDetails?.strUserName)
                                //       ) : (
                                //         <UserOutlined />
                                //       )}
                                //     </Avatar>
                                //   ),
                                //   label: <>{applicationData?.loggedInClient?.userLoginDetails?.strUserName}</>,
                                //   children: items,
                                //   className: 'custom-hover-menu'
                                // }
                            ] })) }), _jsx(Row, { children: _jsxs(Space, { children: [_jsx(Col, { children: _jsx(_Fragment, { children: imageSrc != null && imageSrc != undefined && (_jsx(Tooltip, { color: "#00A4A4", title: (_l = (_k = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _k === void 0 ? void 0 : _k.userLoginDetails) === null || _l === void 0 ? void 0 : _l.strCompanyName, children: _jsx("img", { src: imageSrc, alt: 'company-logo', style: { height: '35px', marginTop: '15px' } }) })) }) }), _jsx(Col, { children: _jsx(Dropdown, { menu: { items }, trigger: ['hover'], children: _jsxs(Space, { children: [_jsx(Avatar, { className: "custom-avator-font-color", size: 28, style: { fontSize: '11px', backgroundColor: color }, children: ((_o = (_m = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _m === void 0 ? void 0 : _m.userLoginDetails) === null || _o === void 0 ? void 0 : _o.strUserName) ? (getInitials((_q = (_p = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _p === void 0 ? void 0 : _p.userLoginDetails) === null || _q === void 0 ? void 0 : _q.strUserName)) : (_jsx(UserOutlined, {})) }), _jsx(Typography.Text, { style: { color: 'white' }, children: (_s = (_r = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _r === void 0 ? void 0 : _r.userLoginDetails) === null || _s === void 0 ? void 0 : _s.strUserName })] }) }) }), _jsx(Col, { children: _jsx(Notifications, {}) })] }) })] }), _jsx(Layout, { children: _jsx(Content, { style: {
                        minHeight: '100vh',
                        background: '#fafafa',
                        padding: '18px'
                    }, children: _jsx(AppRoutes, {}) }) }), _jsxs(Footer, { style: { textAlign: 'center' }, children: ["Copyright \u00A9 Bureau Veritas Group ", new Date().getFullYear()] })] }));
};
export default AppLayout;
